import { Link } from "@remix-run/react"

export function Reach() {
  return (
    <div className="block">
      <h2>Will You Help Us Reach More People?</h2>
      <p>
        Our goal is to reach as many people as possible with the unvarnished
        truth of God&rsquo;s Word.
      </p>
      <Link
        className="line-btn"
        to="/partnership"
        data-testid="reach-people-link"
      >
        Learn how
      </Link>
    </div>
  )
}
